'use client';

import Portal from '@mui/material/Portal';
import { useColorScheme } from '@mui/material/styles';
import { Toaster } from 'sonner';

import { Iconify } from '../iconify';
import { snackbarClasses } from './classes';
import { SnackbarWrapper } from './styles';

// ----------------------------------------------------------------------

export function Snackbar() {
  const { mode } = useColorScheme();

  return (
    <Portal>
      <SnackbarWrapper>
        <Toaster
          theme={mode === 'dark' ? 'dark' : 'light'}
          expand={false}
          gap={12}
          closeButton
          offset={16}
          visibleToasts={3}
          duration={3000}
          position="top-right"
          className={snackbarClasses.root}
          toastOptions={{
            classNames: {
              toast: snackbarClasses.toast,
              icon: snackbarClasses.icon,
              content: snackbarClasses.content,
              title: snackbarClasses.title,
              description: snackbarClasses.description,
              actionButton: snackbarClasses.actionButton,
              cancelButton: snackbarClasses.cancelButton,
              closeButton: snackbarClasses.closeButton,
              default: snackbarClasses.default,
              info: snackbarClasses.info,
              error: snackbarClasses.error,
              success: snackbarClasses.success,
              warning: snackbarClasses.warning,
            },
          }}
          icons={{
            loading: <span className={snackbarClasses.loadingIcon} />,
            info: <Iconify className={snackbarClasses.iconSvg} icon="solar:info-circle-bold" />,
            success: <Iconify className={snackbarClasses.iconSvg} icon="solar:check-circle-bold" />,
            warning: <Iconify className={snackbarClasses.iconSvg} icon="solar:danger-triangle-bold" />,
            error: <Iconify className={snackbarClasses.iconSvg} icon="solar:danger-bold" />,
          }}
        />
      </SnackbarWrapper>
    </Portal>
  );
}
